import { Button } from '../ui/button';

export const TestimonialsPagination = ({ currentTestimonialPage, totalTestimonialPages, previousPage, nextPage }) => (
<div className="flex justify-center items-center space-x-4">
            <Button
              data-testid="testimonials-previous-button"
              onClick={previousPage}
              disabled={currentTestimonialPage === 0}
              className="bg-gray-800 hover:bg-gray-700 disabled:opacity-50"
            >
              Précédent
            </Button>
            <span data-testid="testimonials-pagination-status" className="text-white font-semibold">
              Page {currentTestimonialPage + 1} sur {totalTestimonialPages}
            </span>
            <Button
              data-testid="testimonials-next-button"
              onClick={nextPage}
              disabled={currentTestimonialPage === totalTestimonialPages - 1}
              className="bg-gray-800 hover:bg-gray-700 disabled:opacity-50"
            >
              Suivant
            </Button>
          </div>
);
